<ts-table-view
  cdkDropListGroup
  tsArrowNavigation
  [tsArrowNavigationEnabled]="arrowNavigationEnabled"
  [tsArrowNavigationAnchor]="focusIndexPath"
  [tsArrowNavigationRowsPerSection]="rowsPerSection"
  [tsArrowNavigationIncompleteRowIndexes]="incompleteRowIndexes"
  [tsArrowNavigationFullRowIndexes]="fullRowIndexes"
  [tsArrowNavigationDelegate]="this"
  [stickyHeader]="stickyHeader"
  [locationRow]="locationRow"
  [paddingNodes]="paddingNodes"
  [headerTemplate]="headerTemplate"
  [rowNumeralTemplate]="rowNumeralTemplate"
  [rowTemplate]="rowTemplate"
  [scrollThreshold]="scrollThreshold"
  [loading]="loading"
  [dataSource]="this"
  [scrollDelegate]="scrollDelegate"
  [dragSelectionEnabled]="dragSelectionEnabled"
  [dragSelectionHitTester]="this"
  [dragSelectionDelegate]="$any(dragSelectionDelegate)"
>
  <ng-content slot="loader"></ng-content>

  <div
    #emptyDropList
    *ngIf="{ section: 0, row: -1 } as indexPath"
    class="empty-drop-list"
    slot="no-items"
    [id]="getDropListId(indexPath)"
    cdkDropList
    cdkDropListSortingDisabled="true"
    cdkDropListOrientation="horizontal"
    [cdkDropListConnectedTo]="connectedDropLists"
    (cdkDropListDropped)="onDrop($event)"
  >
    <p *ngIf="!loading">{{ 'label.no_items' | translate }}</p>
  </div>

  <ng-template #rowTemplate let-index>
    <div
      #row
      class="row"
      cdkDropList
      cdkDropListSortingDisabled="true"
      cdkDropListOrientation="horizontal"
      [style.gap]="cellGap + 'px'"
      [id]="getDropListId(index)"
      [cdkDropListConnectedTo]="connectedDropLists"
      (cdkDropListDropped)="onDrop($event)"
    >
      <ng-container *ngFor="let indexPath of getCellIndexes(index); index as column; trackBy: trackByIndex">
        <ts-grid-view-cell
          *ngIf="resolveCell(indexPath) | async as cell"
          cdkDrag
          [data]="cell"
          [template]="cellTemplate"
          [delegate]="delegate"
          [style.height]="cellSize + 'px'"
          [style.width]="cellSize + 'px'"
          [cdkDragDisabled]="draggingDisabled"
          [cdkDragData]="cell"
          (cdkDragStarted)="delegate.cellDraggingStarted(indexPath, cell)"
          (click)="onClicked($event, indexPath, cell)"
          (dblclick)="onDoubleClicked($event, indexPath, cell)"
          (contextmenu)="onContextMenuOpened($event, indexPath, cell)"
        >
        </ts-grid-view-cell>
      </ng-container>
    </div>
  </ng-template>
</ts-table-view>
